import React from 'react';
import { useParams } from 'react-router-dom';

import { TRENDS_LIBRARY_COPY } from 'features/trends/pages/TrendsLibrary/copy';
import CopyLink from 'shared/components/atoms/CopyLink/CopyLink';
import { Flex } from 'shared/components/display';

import styles from './styles';

const { COPY_TEXT, COPIED_TEXT } = TRENDS_LIBRARY_COPY;

interface Props {
  trendId?: number;
  portalTarget?: string | HTMLElement | null;
}
const TrendCopyLink: React.FC<Props> = ({ trendId, portalTarget = 'body' }) => {
  const { organizationId, accountId } = useParams<{ organizationId: string; accountId: string }>();
  const searchParams = new URLSearchParams({
    orgId: organizationId,
    accountId: accountId,
    ...(trendId && { trendId: trendId.toString() }),
  });

  return (
    <Flex css={styles} className="trend-copy-link">
      <CopyLink
        className="trend-copy-link__btn"
        text={COPY_TEXT}
        copiedText={COPIED_TEXT}
        link={`${window.location.origin}/trends?${searchParams.toString()}`}
        tooltipPlacement="top-start"
        portalTarget={portalTarget}
      />
    </Flex>
  );
};

export default TrendCopyLink;
